import { Input, EVisualSize } from '@cian/ui-kit/prev';
import { mergeStyles } from '@cian/utils';
import { Field } from 'formik';
import * as React from 'react';

import * as styles from '../index.css';
import { Label } from './Label';
import { useFieldHasErrors } from './utils';

export const ActivityScope = () => {
  const invalid = useFieldHasErrors('activityScope');

  return (
    <div {...mergeStyles(styles['field'], styles['span-columns'])}>
      <Label invalid={invalid}>Сфера деятельности</Label>
      <Field
        name="activityScope"
        as={Input}
        placeholder="Профессия или компания"
        custom={{ invalid, size: EVisualSize.DESKTOP }}
      />
    </div>
  );
};
